// extracted by mini-css-extract-plugin
export var body = "styles-module--body--03839";
export var container = "styles-module--container--a9d94";
export var content = "styles-module--content--07d98";
export var image = "styles-module--image--8972a";
export var section = "styles-module--section--f3339";
export var title = "styles-module--title--bfba0";